import { Button, type ButtonProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function ButtonDetails(props: ButtonProps & { onClick?: () => void }) {
  const { t } = useTranslation()
  return (
    <Button variant="info" size="compact-md" {...props}>
      {t("See details")}
    </Button>
  )
}
